import { HeartHandshake, Compass, Wind, CloudRain, Route, Sprout, FileSearch } from "lucide-react";
import { Reveal, ChapterHeader } from "./Reveal";

const AREAS = [
  {
    icon: HeartHandshake,
    title: "Trauma recovery & emotional adjustment",
    text: "Gentle, paced work that helps the nervous system settle and life feel liveable again after overwhelming experiences.",
    span: "md:col-span-2",
  },
  {
    icon: Compass,
    title: "Identity & masculinity work",
    text: "A space to explore who you are becoming, including honest, unhurried conversations about manhood and self.",
    span: "",
  },
  {
    icon: Wind,
    title: "Anxiety",
    text: "Understanding worry's patterns and building calm, practical ways of meeting each day.",
    span: "",
  },
  {
    icon: CloudRain,
    title: "Depression",
    text: "Compassionate support to lift heaviness, restore meaning and reconnect with what matters.",
    span: "",
  },
  {
    icon: Route,
    title: "Life transitions & change",
    text: "Loss, relocation, new chapters: steady companionship while the ground shifts beneath you.",
    span: "",
  },
  {
    icon: Sprout,
    title: "Youth resilience & growth",
    text: "Early psychological support that builds strong foundations for lifelong wellbeing.",
    span: "",
  },
  {
    icon: FileSearch,
    title: "Psychometric & psycho-legal assessment",
    text: "Thorough assessment and reporting for educational, personal and medico-legal contexts.",
    span: "md:col-span-2",
  },
];

export const FocusAreas = () => (
  <section id="focus" data-testid="focus-section" className="py-24 md:py-32 bg-pawc-sand">
    <div className="max-w-6xl mx-auto px-6">
      <ChapterHeader number="04" eyebrow="Areas of Focus" title="Where our work together may lead" />

      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {AREAS.map((a, i) => (
          <Reveal key={a.title} delay={0.05 * i} className={a.span}>
            <article
              data-testid={`focus-card-${i}`}
              className="group h-full rounded-2xl bg-pawc-paper border border-pawc-teal/10 p-8 hover:border-pawc-teal/30 hover:-translate-y-1 transition-[transform,border-color] duration-500"
            >
              <span className="inline-flex w-11 h-11 rounded-full bg-pawc-teal/10 text-pawc-teal items-center justify-center mb-5 group-hover:bg-pawc-terra/15 group-hover:text-pawc-terra transition-colors duration-500">
                <a.icon size={20} strokeWidth={1.5} />
              </span>
              <h3 className="font-serif text-xl md:text-2xl text-pawc-deep mb-3">{a.title}</h3>
              <p className="text-sm md:text-base text-pawc-slate leading-relaxed">{a.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
